export const siteMeta = {
  name: "St. Arsema Ethiopian Orthodox Tewahido Church",
  shortName: "St. Arsema EOTC",
  logoPath: "/st-arsema-logo.png",
  city: "Madison, Wisconsin",
  tagline: "Ancient faith, living worship, and a welcoming community in Christ.",
  mission:
    "We gather in prayer, sacramental life, teaching, and service while preserving the sacred tradition of the Ethiopian Orthodox Tewahido Church.",
  addressLine1: "11 N 7th Street",
  addressLine2: "Madison, WI 53704",
  meetingLocation:
    "Assumption Greek Orthodox Church, lower level gathering space",
  email: "arsema.saint@gmail.com",
  phone: "(608) 456-7890",
  phoneHref: "tel:+16084567890",
  emailHref: "mailto:arsema.saint@gmail.com",
  mapsUrl: "https://maps.google.com/?q=11+N+7th+Street+Madison+WI+53704",
  livestreamUrl: "#",
  donationUrl: "/donations",
};

export const socialLinks = [
  { label: "YouTube", href: siteMeta.livestreamUrl },
];

export const navigation = [
  { name: "Home", page: "Home" },
  { name: "About", page: "About" },
  { name: "Services & Events", page: "Events" },
  { name: "Sermons", page: "Sermons" },
  { name: "Member Portal", page: "MemberPortal" },
  { name: "Login", page: "Login" },
  { name: "Donation", page: "Donations" },
  { name: "Calendar", page: "Calendar" },
  { name: "Contact", page: "Contact" },
];

export const serviceSchedule = [
  {
    title: "Every Other Saturday Sermon and Prayer",
    time: "4:00 PM to 7:00 PM",
    detail:
      "Our parish gathers for worship, fellowship, and teaching every other Saturday in Madison.",
  },
  {
    title: "Children and Youth Formation",
    time: "During parish gatherings",
    detail:
      "Young people receive age-appropriate Orthodox instruction and community support.",
  },
  {
    title: "Feast Day and Special Services",
    time: "As announced",
    detail:
      "Additional liturgies, fasts, and feast celebrations are shared through parish communication channels.",
  },
];

export const homeHighlights = [
  {
    title: "Worship",
    description:
      "A prayerful community formed by Scripture, fasting, holy tradition, and sacramental life.",
  },
  {
    title: "Belonging",
    description:
      "A spiritual home for Ethiopian and Eritrean Orthodox families, students, and newcomers in Madison.",
  },
  {
    title: "Formation",
    description:
      "Teaching for children, youth, and adults so the faith is not only preserved, but practiced.",
  },
];

export const quickLinks = [
  {
    title: "Plan Your Visit",
    description: "Directions, service rhythm, and what to expect when you arrive.",
    page: "Contact",
  },
  {
    title: "Learn Our Story",
    description:
      "Read about the parish mission and the heritage of the Ethiopian Orthodox Church.",
    page: "About",
  },
  {
    title: "See Upcoming Gatherings",
    description:
      "Stay current with worship times, parish events, and community fellowship.",
    page: "Events",
  },
  {
    title: "Support the Parish",
    description:
      "Give securely toward worship, ministry, outreach, and future church needs.",
    page: "Donations",
  },
];

export const events = [
  {
    title: "Parish Sermon and Prayer Gathering",
    category: "Worship",
    dateLabel: "Every other Saturday",
    time: "4:00 PM to 7:00 PM",
    location: "11 N 7th Street, Madison, WI 53704",
    featured: true,
    description:
      "Our regular parish gathering for worship, prayer, teaching, and shared fellowship.",
  },
  {
    title: "Youth Fellowship and Teaching",
    category: "Youth",
    dateLabel: "Every other Saturday",
    time: "4:00 PM to 7:00 PM",
    location: "11 N 7th Street, Madison, WI 53704",
    featured: false,
    description:
      "Young people gather for faith formation, discussion, and community rooted in Orthodox life.",
  },
  {
    title: "Parish Building and Stewardship Updates",
    category: "Community",
    dateLabel: "Scheduled as needed",
    time: "After the main gathering",
    location: "On site and through parish communications",
    featured: false,
    description:
      "Members receive ministry updates, stewardship news, and next steps as the parish grows.",
  },
];

export const sermons = [
  {
    title: "Holding Fast to the Faith",
    speaker: "Mr. Eshetu Zatu",
    dateLabel: "Recent parish teaching",
    scripture: "Hebrews 11",
    summary:
      "An encouragement to remain faithful, prayerful, and steadfast in the life of the Church.",
    audioUrl: "",
    videoUrl: "",
  },
  {
    title: "Prayer, Patience, and Orthodox Witness",
    speaker: "Parish teaching team",
    dateLabel: "Parish archive item",
    scripture: "Romans 12",
    summary:
      "A reflection on how worship shapes daily life, family formation, and service to the community.",
    audioUrl: "",
    videoUrl: "",
  },
];

export const givingFunds = [
  {
    title: "General Offering",
    description:
      "Supports worship, parish operations, hospitality, and day-to-day ministry needs.",
  },
  {
    title: "Building and Future Church Home",
    description:
      "Helps the parish prepare for long-term space needs and a permanent church home.",
  },
  {
    title: "Mercy and Community Care",
    description:
      "Supports members and neighbors facing hardship through practical parish assistance.",
  },
];

export const givingMethods = [
  {
    title: "Online Giving",
    description:
      "Use our secure donation page to make a one-time gift or set up recurring support.",
  },
  {
    title: "In Person",
    description:
      "Offer gifts during parish gatherings and feast day services using the normal church collection process.",
  },
  {
    title: "Parish Contact",
    description:
      "Reach out to the church office if you need help with stewardship questions or special giving arrangements.",
  },
];

export const aboutBeliefs = [
  {
    title: "Holy Trinity",
    description:
      "We worship the one God in Trinity: Father, Son, and Holy Spirit, one essence and one divinity.",
  },
  {
    title: "Holy Scripture and Tradition",
    description:
      "We receive the Holy Scriptures and the living tradition of the Church as a unified witness to salvation.",
  },
  {
    title: "Sacramental Life",
    description:
      "Baptism, Eucharist, confession, fasting, and prayer shape the ordinary rhythm of Orthodox Christian life.",
  },
  {
    title: "The Communion of Saints",
    description:
      "We honor the Theotokos and the saints as faithful witnesses whose lives direct us to Christ.",
  },
];

export const aboutValues = [
  "Faithfulness to Orthodox worship and doctrine",
  "Hospitality toward families, students, and first-time visitors",
  "Formation of children and youth in the life of the Church",
  "Stewardship that prepares the parish for future growth",
];

export const leaders = [
  {
    name: "Dr. Mulugeta",
    title: "Parish Director",
    description: "Supports parish coordination, communication, and community stewardship.",
  },
  {
    name: "Dr. Daniel",
    title: "Parish Secretary",
    description: "Helps manage administration and keeps the community connected to parish life.",
  },
  {
    name: "Deacon Biru",
    title: "Deacon",
    description: "Serves the liturgical life of the parish and supports worship preparation.",
  },
  {
    name: "Mr. Eshetu",
    title: "Sunday School Leader",
    description: "Helps lead religious education and faith formation for the next generation.",
  },
];

export const feastDays = [
  {
    title: "Genna",
    dateLabel: "January 7",
    description: "The Ethiopian Orthodox celebration of the Nativity of our Lord Jesus Christ.",
  },
  {
    title: "Timkat",
    dateLabel: "January 19",
    description: "The feast of the Lord's baptism and a major celebration in the Church year.",
  },
  {
    title: "Fasika",
    dateLabel: "Movable feast",
    description: "The Resurrection of Christ, celebrated according to the Ethiopian Orthodox calendar.",
  },
  {
    title: "Meskel",
    dateLabel: "September 27",
    description: "The finding of the True Cross and one of the most beloved feasts of the year.",
  },
];

export const fastSeasons = [
  {
    title: "Fast of Nineveh",
    dateLabel: "Three days, movable",
    description: "A season of repentance recalling the people of Nineveh.",
  },
  {
    title: "Great Lent",
    dateLabel: "Fifty-five days before Fasika",
    description: "A sustained fast of repentance and preparation for Holy Week and Easter.",
  },
  {
    title: "Filseta Fast",
    dateLabel: "Mid-August",
    description: "A period of fasting and prayer connected to the commemoration of Saint Mary.",
  },
  {
    title: "Weekly Wednesday and Friday Fasts",
    dateLabel: "Throughout most of the year",
    description: "A continuing rhythm of remembrance, repentance, and spiritual discipline.",
  },
];

export const memberPortalFeatures = [
  "Parish announcements and member communications",
  "Volunteer sign-ups and ministry coordination",
  "Private schedules, forms, and family resources",
];
